import LutticaScrollBar from './LutticaScrollBar/index.vue';
import LutticaIcon from './LutticaIcon/index.vue';
import LutticaDataGrid from './LutticaDataGrid/index.vue';
import LutticaModal from './LutticaModal/index.vue';

const lutticaComponents = {
  LutticaScrollBar,
  LutticaIcon,
  LutticaDataGrid,
  LutticaModal,
};

const install = Vue => {
  if (install.installed) return;
  Object.keys(lutticaComponents).forEach(key => {
    Vue.component(key, lutticaComponents[key]);
  });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

const LutticaComponents = {
  install,
  ...lutticaComponents,
};

export default LutticaComponents;
